export default "__VITE_ASSET__76ce47a9__"